import {
    useEffect,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import PolicyDocument from "./components/PolicyDocument";

import {
    fetchPoliciesAction,
} from "../../state/actions/policyActions";

const TermsAndConditions = () => {
    const dispatch =
        useDispatch();

    const {
        policies,
        loading,
    } = useSelector(
        (
            state
        ) =>
            state.policy
    );

    useEffect(() => {
        dispatch(
            fetchPoliciesAction()
        );
    }, [
        dispatch,
    ]);

    const document =
        policies.find(
            (
                policy
            ) =>
                policy.title ===
                "Mogoma Driver Partner Programme Terms & Conditions"
        );

    return (
        <PolicyDocument
            type="terms"
            document={
                document
            }
            loading={
                loading
            }
        />
    );
};

export default TermsAndConditions;